import React from 'react';
import { Panel, Badge, Button } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import DeckPreviewCard from './DeckPreviewCard';
import { formatContainerCount } from '../../helpers/containerCountLabel';

const CollectionCard = ({
  collection,
  previewImageUrl,
  onDelete,
  onMove,
  showMoveButton,
  typeBadge,
  visibilityBadge,
  legalityBadge,
  styles,
  FONT,
  COLORS,
  SPACING,
}) => {
  const navigate = useNavigate();

  return (
    <Panel
      bordered
      bodyFill
      onClick={() => navigate(`/library/${collection.id}`)}
      style={{ padding: SPACING.cardPadding }}
    >
      <div style={{ ...styles.cardHeader, flexDirection: 'row', alignItems: 'flex-start' }}>
        <DeckPreviewCard imageUrl={previewImageUrl} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={styles.cardTitle}>
            <span style={{ fontSize: FONT.collectionName, fontWeight: 600 }}>
              {collection.name}
            </span>
            {typeBadge(collection.type)}
            {visibilityBadge(collection.visibility)}
            {collection.deck_type && (
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: SPACING.badgeMarginLeft,
                }}
              >
                <span
                  style={{
                    fontSize: FONT.deckType,
                    color: COLORS.muted,
                  }}
                >
                  {collection.deck_type}
                </span>
                {legalityBadge(collection)}
              </span>
            )}
          </div>
          <div style={styles.actions}>
            <Badge content={formatContainerCount(collection)} />
            {showMoveButton && (
              <Button
                size="xs"
                appearance="ghost"
                onClick={(e) => {
                  e.stopPropagation();
                  onMove(collection);
                }}
              >
                Move to Folder
              </Button>
            )}
            <Button
              size="xs"
              color="red"
              appearance="ghost"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(collection);
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
      {collection.description && (
        <p
          style={{
            marginTop: SPACING.descriptionMarginTop,
            color: COLORS.muted,
            fontSize: FONT.description,
          }}
        >
          {collection.description}
        </p>
      )}
    </Panel>
  );
};

export default CollectionCard;
